import { render, staticRenderFns } from "./BirthdayPicker.vue?vue&type=template&id=3734cd26&scoped=true"
import script from "./BirthdayPicker.vue?vue&type=script&lang=js"
export * from "./BirthdayPicker.vue?vue&type=script&lang=js"
import style0 from "./BirthdayPicker.vue?vue&type=style&index=0&id=3734cd26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3734cd26",
  null
  
)

export default component.exports